import { Navigate } from 'react-router-dom';

import NotAuthorized from '@pages/auth/NotAuthorized';

import middleware from '@middlewares/middleware';
import { getVars } from '@utils/global';

const titleVerify = ({ title = null }) => {
  if (title) {
    title = title.trim();

    // Verificar y eliminar cualquier variante de "- GTO" al final
    const patterns = [' - GTO', '- GTO', '-GTO', '-'];
    for (const pattern of patterns) {
      if (title.endsWith(pattern)) {
        title = title.slice(0, -pattern.length).trim();
        break;
      }
    }

    document.title = title + ' - GTO';
  } else document.title = 'GTO';
};

export const Public = ({ children, page = null, title = null }) => {
  titleVerify({ title });
  return !middleware.getValidToken() ? page ?? children : <Navigate to={getVars('Token').user.DefaultPage} />;
};

export const AlreadyLoggedIn = ({ children }) => {
  return middleware.getValidToken() ? (
    <Navigate to={getVars('Token').user.DefaultPage} />
  ) : (
    <Navigate to={'/login'} />
  );
};

export const ProtectedRoute = ({ children, page = null, title = null }) => {
  titleVerify({ title });
  return middleware.getValidToken() ? page ?? children : <Navigate to={'/login'} />;
};

export const PrivilegedRoute = ({ children, page = null, title = null }) => {
  titleVerify({ title });
  return middleware.checkMenuAccess() ? page ?? children : <NotAuthorized />;
};
